/**
 * Collection Support Functions
 * Shopify Theme v2.0.1
 * 
 * Handles collection filtering, sorting, and product display
 * Required for: Collection pages, Product listing
 */

(function() {
    'use strict';
    
    // Collection configuration
    var collectionConfig = {
        enableFilter: true,
        enableSort: true,
        enablePagination: true,
        productsPerPage: 24,
        enableInfiniteScroll: true
    };
    
    // Cache DOM elements
    var collectionContainer = document.querySelector('.collection-container');
    var productGrid = document.querySelector('.product-grid');
    var filterButtons = document.querySelectorAll('.filter-button');
    var sortSelect = document.querySelector('.sort-select');
    var loadMoreButton = document.querySelector('.load-more-button');
    var paginationLinks = document.querySelectorAll('.pagination a');
    
    // Helper functions
    function getUrlParams() {
        var params = {};
        var queryString = window.location.search.substring(1);
        var pairs = queryString.split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            if (pair.length === 2) {
                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            }
        }
        return params;
    }
    
    function updateUrlParams(params) {
        var currentParams = getUrlParams();
        for (var key in params) {
            currentParams[key] = params[key];
        }
        var queryString = '';
        for (var key in currentParams) {
            if (currentParams[key]) {
                queryString += (queryString ? '&' : '?') + encodeURIComponent(key) + '=' + encodeURIComponent(currentParams[key]);
            }
        }
        window.history.pushState({}, '', window.location.pathname + queryString);
    }
    
    // Initialize collection functionality
    function initCollection() {
        // Setup filter buttons
        if (filterButtons.length) {
            filterButtons.forEach(function(button) {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    var filter = this.getAttribute('data-filter');
                    var currentFilter = getUrlParams().filter;
                    if (currentFilter === filter) {
                        delete getUrlParams().filter;
                        updateUrlParams({ filter: '' });
                    } else {
                        updateUrlParams({ filter: filter });
                    }
                    window.location.reload();
                });
            });
        }
        
        // Setup sort functionality
        if (sortSelect) {
            sortSelect.addEventListener('change', function() {
                var sortValue = this.value;
                updateUrlParams({ sort: sortValue });
                window.location.reload();
            });
        }
        
        // Setup pagination
        if (paginationLinks.length) {
            paginationLinks.forEach(function(link) {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    var page = this.getAttribute('data-page');
                    if (page) {
                        updateUrlParams({ page: page });
                        window.location.reload();
                    }
                });
            });
        }
        
        // Setup load more button
        if (loadMoreButton) {
            loadMoreButton.addEventListener('click', function(e) {
                e.preventDefault();
                var nextPage = parseInt(this.getAttribute('data-page')) + 1;
                var url = this.getAttribute('data-url') + '?page=' + nextPage;
                window.location.href = url;
            });
        }
        
        // Setup infinite scroll
        if (collectionConfig.enableInfiniteScroll) {
            var scrollTimeout;
            window.addEventListener('scroll', function() {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(function() {
                    var scrollHeight = document.documentElement.scrollHeight;
                    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    var windowHeight = window.innerHeight;
                    
                    if (scrollTop + windowHeight >= scrollHeight - 200) {
                        if (loadMoreButton && loadMoreButton.getAttribute('data-page')) {
                            loadMoreButton.click();
                        }
                    }
                }, 200);
            });
        }
        
        // Process product items
        var productItems = document.querySelectorAll('.product-item');
        if (productItems.length) {
            productItems.forEach(function(item, index) {
                // Add animation delay to items
                item.style.animationDelay = (index * 0.05) + 's';
            });
        }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCollection);
    } else {
        initCollection();
    }
    
})();